<template>
  <div class="self_adaption">
    <div class="self_adaption_main">
      <el-form ref="form" :model="form" label-width="96px" label-position="right" class="FormFlex"
        style="justify-content: space-between;">
        <div class="FormBtn" style="width:100%;display:flex;justify-content:flex-end;">
          <el-button type="success" size="medium" @click="addSpeak()">添加问答内容</el-button>
        </div>
      </el-form>
      <div v-for="(item, index) in Data" :key="index">
        <el-table class="table_header" :data="[item]" border style="width: 100%" :show-header="status">
          <el-table-column align="center" label="日期" width="60">
            <template>
              {{ $nzhcn.encodeS(index + 1) }}.
            </template>
          </el-table-column>
          <el-table-column label="内容">
            <template v-slot="scoped">
              <span style="font-weight: bold; white-space: pre-wrap;word-wrap: break-word;" v-html="scoped.row.speaker + ':' + scoped.row.content">

              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="address" label="操作" width="220">
            <template v-slot="scoped">
              <el-tag style="margin:0px 5px" @click="editData('all', scoped.row)" size="small"
                class="cursor">整体编辑</el-tag>
              <el-tag style="margin:0px 5px" @click="delData('all', scoped.row)" size="small"
                class="cursor">整体删除</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="item.children" border style="width: 100%" :show-header="status">
          <el-table-column align="center" type="index" label="序号" width="60"></el-table-column>
          <el-table-column align="left" prop="content" label="内容">
            <template v-slot="scoped">
              <div>{{scoped.row.speaker+'：'}}</div>
             <div  class="div-table-content" v-html="scoped.row.content"></div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="220">
            <template v-slot="scoped">
              <el-tag style="margin:0px 5px" @click="editData('one', scoped.row)" size="small"
                class="cursor">编辑</el-tag>
              <el-tag style="margin:0px 5px" @click="delData('one', scoped.row)" size="small" class="cursor">删除</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增/修改 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="新增问答内容" :visible.sync="dialogVisible"
      width="50%">
      <el-form ref="submitFormTop" :model="submitFormTop" label-width="96px" label-position="right" class="FormFlex"
        style="justify-content: space-between;">
        <el-form-item label="提问人：">
          <el-input v-model="submitFormTop.name" placeholder="请输入发言人" border="none"></el-input>
        </el-form-item>
      </el-form>
      <el-table ref="multipleTable" :data="tableDataTop" tooltip-effect="dark" style="width: 100%;margin-bottom: 30px;"
        border>
        <el-table-column align="center" label="提问内容">
          <template v-slot="scoped">
            <el-input placeholder="请输入问题" type="textarea" show-word-limit maxlength="500"
              :autosize="{ minRows: 3, maxRows: 6 }" v-model="scoped.row.content"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-form ref="submitForm" :model="submitForm" label-width="132px" label-position="right" class="FormFlex"
        style="justify-content: space-between;">
        <el-form-item label="发言人/主持人：">
          <el-select v-model="submitForm.attendeeId" filterable placeholder="请选择发言人/主持人" @change="selectChange">
            <el-option v-for="(item, index) in options" :key="index" :label="item.duty + item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="FormBtn" style="display:flex;justify-content:flex-end;">
          <el-button size="mini" type="success" icon="el-icon-plus" @click="add()"></el-button>
          <el-button size="mini" type="danger" icon="el-icon-minus" @click="del()"></el-button>
        </div>
      </el-form>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border>
        <el-table-column align="center" label="序号" width="60" type="index"></el-table-column>
        <el-table-column align="center" label="发言内容">
          <template slot-scope="scoped">
            <el-input type="textarea"  :rows="8" v-model="scoped.row.content" placeholder="请输入发言内容" border="none"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="submitDiv">
        <el-button type="success" @click="submit()">确认</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑单个 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="编辑发言内容"
      :visible.sync="dialogVisibleOne" width="50%">
      <el-table ref="multipleTable" :data="tableDataOne" tooltip-effect="dark" style="width: 100%" border>
        <el-table-column align="center" label="序号" width="60" type="index"></el-table-column>
        <el-table-column align="center" label="发言内容">
          <template slot-scope="scoped">
            <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 30}" v-model="scoped.row.content" placeholder="请输入发言内容" border="none"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="submitDiv">
        <el-button type="success" @click="submitEdit()">确认</el-button>
        <el-button type="success" @click="dialogVisibleOne = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  surveyquestionsAnswers,
  surveyAttendList,
  surveySpeechSave,
  surveySpeechSaveSingle,
  surveyquestionsAnswersDel,
  surveySpeechDelById,
  surveyquestionsAnswersEdit,
  surveySpeechEditById
} from '@/api/axiosUrl';
import {lineBrake2Dom} from "@/utils/tools";

export default {
  name: 'Progress',
  components: {},
  props: { dataId: String },
  data () {
    return {
      status: false,
      dialogVisible: false,
      dialogVisibleOne: false,
      form: {},
      select: {},
      options: [],
      submitFormTop: {},
      submitForm: {},
      tableDataTop: [{
        content: ''
      }],
      tableData: [{
        content: '',
        orderNo: '1'
      }],
      editOne: {},
      editAll: [],
      tableDataOne: [],
      Data: []
    };
  },
  created () {
    surveyAttendList({ surveyId: this.dataId }).then(res => {
      if (res.data.length) {
        this.options = res.data
      }
    });
    this.renderData();
  },
  methods: {
    addSpeak () {
      this.dialogVisible = true;
      this.tableData = [{
        content: '',
        orderNo: '1'
      }]
      this.$set(this, 'submitForm', {})
      this.$set(this, 'submitFormTop', {})
      this.$set(this, 'tableDataTop', [{
        content: ''
      }])
    },
    //进入页面去渲染数据
    renderData () {
      this.Data = []
      surveyquestionsAnswers({ surveyId: this.dataId, unEqType: 0 }).then(res => {
        if (res.data.length) {
          const parlist = res.data.filter((item) => { return item.speechType === 1 })
          const childlist = res.data.filter((item) => { return item.speechType === 2 })
          parlist.forEach((item) => {
            item.children = []
            item.content = lineBrake2Dom(item.content, "p")
            childlist.forEach(element => {
              if (element.question === item.id) {
                element.content = lineBrake2Dom(element.content, "p")
                item.children.push(element)
              }
            });
          })
          this.Data = parlist
          console.log(this.Data)
        }
      });
    },
    selectChange (val) {
      for (let i = 0; i < this.options.length; i++) {
        if (val == this.options[i].id) {
          this.selectForm = this.options[i]
          break
        }
      }
    },
    add () {
      let attendeeId = this.tableData[0].attendeeId
      let speaker = this.tableData[0].speaker
      let speechType = 0
      let surveyId = this.tableData[0].surveyId
      let orderNo = this.tableData.length+1
      this.tableData.push({ content: '',attendeeId: attendeeId,speaker: speaker,speechType: speechType,surveyId: surveyId,orderNo: orderNo })
    },
    del () {
      if (this.tableData.length == 1) {
        this.$message('至少保留一个', 'warning')
      } else {
        this.tableData.splice(-1, 1)
      }
    },
    submit () {
      let _this = this
      var params = JSON.parse(JSON.stringify(this.tableData))
      this.selectChange(this.submitForm.attendeeId)
      for (let i = 0; i < params.length; i++) {
        params[i].attendeeId = this.selectForm.id
        params[i].speaker = this.selectForm.duty + ' ' + this.selectForm.name
        params[i].speechType = 2
        params[i].surveyId = this.selectForm.surveyId
      }
      params.unshift({
        speechType: 1,
        surveyId: this.selectForm.surveyId,
        id: this.submitFormTop.id,
        speaker: this.submitFormTop.name,
        content: this.tableDataTop[0].content
      })
      surveySpeechSave({ speeches: params,groupId:this.tableData[0].groupId }).then(res => {
        if (res.status == 200) {
          this.$message.success('保存成功')
          setTimeout(function () {
            _this.dialogVisible = false
            _this.renderData()
          }, 500)
        }
      })
    },
    // 编辑
    editData (flag, data) {
      let _this = this
      _this.tableDataOne = []
      _this.submitFormTop = {}
      if (flag == 'all') {
        _this.dialogVisible = true
        this.$set(_this.submitFormTop, 'id', data.id)
        this.$set(_this.submitFormTop, 'name', data.speaker)
        this.$set(_this.tableDataTop[0], 'content', data.content)
        this.$set(_this.submitForm, 'attendeeId', data.children[0].attendeeId)
        console.log(data.children[0])
        _this.tableData = data.children
        surveyquestionsAnswersEdit({ questionId: data.id }).then(res => {
          if (res.status == 200) {
            for (let i = 0; i < res.data.length; i++) {
              _this.tableDataOne.push(res.data[i])
            }
          }
        })
      } else {
        _this.dialogVisibleOne = true
        surveySpeechEditById({ id: data.id }).then(res => {
          if (res.status == 200) {
            _this.tableDataOne.push(res.data)
          }
        })
      }
    },
    // 保存编辑单个和多个
    submitEdit () {
      let _this = this
      var params = {
        id: this.tableDataOne[0].id,
        content: this.tableDataOne[0].content
      }
      surveySpeechSaveSingle(params).then(res => {
        if (res.status == 200) {
          this.$message.success('修改成功')
          setTimeout(function () {
            _this.dialogVisibleOne = false
            _this.renderData()
          }, 500)
        }
      })
    },
    //整体删除和删除单个
    delData (flag, data) {
      let _this = this
      _this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var params = {}
        if (flag == 'all') {
          surveyquestionsAnswersDel({ questionId: data.id }).then(res => {
            if (res.status == 200) {
              _this.$message.success('删除成功')
              _this.renderData()
            } else {
              _this.$message.error('删除失败')
            }
          })
        } else {
          params.id = data.id
          surveySpeechDelById({ id: data.id }).then(res => {
            if (res.status == 200) {
              _this.$message.success('删除成功')
              _this.renderData()
            } else {
              _this.$message.error('删除失败')
            }
          })
        }
      })
    },
  }
};
</script>

<style scoped>
::v-deep .table_header tr {
  background: #F2F2F2 !important;
}

::v-deep .table_header tr:hover {
  background: #F2F2F2 !important;

}
.div-table-content {
  text-align: left;
  /*text-indent: 2em;*/
  white-space:pre-wrap;
}
</style>
